module.exports = __webpack_public_path__ + "assets/close-popup-fa7304.svg";